// import { useState, useEffect } from "react";
// import axios from "axios";
// import { switchEndpoint } from "../../../../../../redux/actions/endpoints";


// const useFetchWasteData = () => {
//   const [categories, setCategories] = useState([]);
//   const [pricingData, setPricingData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchWasteData = async () => {
//       setLoading(true);
//       try {
//         const token = storage.getItem("token");
//         const response = await axios.get(
//           `${switchEndpoint}/group-waste-categories`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const data = response.data || {};
//         console.log(data)
//         // Full pricing data for tier lookups and validation
//         setPricingData(data);

//         // Build category list — one entry per key with at least one active tier
//         const normalised = Object.entries(data)
//           .filter(([, tiers]) => tiers.some((t) => t.status === "active"))
//           .map(([name, tiers]) => {
//             const activeTier = tiers.find((t) => t.status === "active");
//             return {
//               id: name,
//               label: activeTier.display_name,
//               pricingKey: name,
//             };
//           });

//         setCategories(normalised);
//       } catch (err) {
//         console.log(err)
//         setError(err.response?.data?.message || "Failed to load categories");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchWasteData();
//   }, []);

//   return { categories, pricingData, loading, error };
// };

// export default useFetchWasteData;


import { useState, useEffect } from "react";
import axios from "axios";
import { switchEndpoint } from "../../../../../../redux/actions/endpoints";
import { storage } from "../../../../../../scopedStorage";
/**
 * Fetches both the category list and tiered pricing in parallel.
 *
 * /waste-categories      → flat array  → used for category list + labels
 * /all-waste-categories  → grouped obj → used for tiered pricing + validation
 *
 * Returns:
 * - categories: [{ id, label, pricingKey }, ...]
 * - pricingData: { "tin_can": [...tiers], "clean_sorted": [...tiers], ... }
 */

// Converts snake_case to readable label
// e.g. "clean_sorted" → "Clean Sorted"
const toLabel = (name) =>
  name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const useFetchWasteData = () => {
  const [categories, setCategories] = useState([]);
  const [pricingData, setPricingData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWasteData = async () => {
      setLoading(true);
      try {
        const token = storage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        // Fire both requests in parallel
        const [categoriesRes, pricingRes] = await Promise.all([
          axios.get(`${switchEndpoint}/group-waste-categories`, { headers }),
          axios.get(`${switchEndpoint}/all-waste-categories`, { headers }),
        ]);

        // ── Category list from /waste-categories (flat array) ──
        const normalised = (categoriesRes.data || [])
          .filter((cat) => cat.pickup_active === true)
          .map((cat) => ({
            id: cat.uid,           // unique key for React + state
            label: toLabel(cat.name),
            pricingKey: cat.name,  // matches key in /all-waste-categories
          }));

        setCategories(normalised);

        // ── Tiered pricing from /all-waste-categories (grouped object) ──
        setPricingData(pricingRes.data || {});

      } catch (err) {
        setError(err.response?.data?.message || "Failed to load categories");
      } finally {
        setLoading(false);
      }
    };

    fetchWasteData();
  }, []);

  return { categories, pricingData, loading, error };
};

export default useFetchWasteData;